import { useState, useRef } from "react";

import { useNavigate } from "react-router-dom";
import api from "@helpers/api";

import { useCommunity } from "@contexts/CommunityContext";

import CustomModal from "@components/CustomModal";
import ImageImportTool from "@components/ImageImportTool";
import { Input } from "@fragments";
import { Divider, Switch } from "@mui/material";

import "./styles.css";
import { BoltRounded, DirectionsRunRounded, ShutterSpeedRounded } from "@mui/icons-material";

export default function PublishPostModal({ modalRef }) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const { loadCommunities, community } = useCommunity();

    const REF_config = useRef({});
    const REF_callback = useRef();

    const nav = useNavigate();

    const exerciseOptions = {
        'duration': [
            {
                title: "15 min",
                value: 15
            },
            {
                title: "30 min",
                value: 30
            },
            {
                title: "45 min",
                value: 45
            },
            {
                title: "1h",
                value: 60
            }
        ],
        'intensity': [
            {
                title: "Baixa",
                value: 'low'
            },
            {
                title: "Moderada",
                value: 'medium'
            },
            {
                title: "Alta",
                value: 'high'
            }
        ],
        'mode': [
            {
                title: "Musculação",
                value: 'gym'
            },
            {
                title: "Corrida",
                value: 'running'
            },
            {
                title: "Ciclismo",
                value: 'cycling'
            },
            {
                title: "Caminhada",
                value: 'walking'
            },
            {
                title: "Natação",
                value: 'swimming'
            }
        ]
    }

    const [exerciseRegistry, setExerciseRegistry] = useState(false);

    modalRef.current = {
        open(preFill, callback) {
            REF_config.current = { ...preFill, activity: { duration: 60, intensity: 'medium', mode: 'gym' } };
            REF_callback.current = callback;
            setOpen(true);
        },
    };

    async function handleSubmit() {
        try {
            setLoading(true);

            const payload = getPayload();

            const { data } = await api.post("community/post", payload);

            if (data.id) {
                await REF_callback.current(data);
                setOpen(false);
            }
        } catch (e) {
            console.log(e);
        }

        setLoading(false);

        function getPayload() {
            const data = {
                group_id: REF_config.current.group,
                text: REF_config.current.text,
                photo: REF_config.current.photo,
                visibility: 'public',
            }

            if (exerciseRegistry) {
                data.activity = {
                    duration: REF_config.current.activity.duration,
                    intensity: REF_config.current.activity.intensity,
                    mode: REF_config.current.activity.mode
                }
            }

            return data;
        }
    }

    function Asset() {
        return (
            <div className="banner-add mt-2">
                <span>Imagem</span>

                <ImageImportTool
                    aspectRatio={1}
                    size={120}
                    imageMaxWidth={1080}
                    src={
                        REF_config.current.photo
                    }
                    onCrop={(imageBase64) => {
                        REF_config.current.photo = imageBase64;
                    }}
                    title="Redimensionar post"
                />
            </div>
        )
    }
    function Message() {
        return (
            <Input.Text
                className="mt-4"
                placeholder="Insira uma mensagem"
                value={REF_config.current.text}
                onInput={(v) => {
                    REF_config.current.text = v;
                }}
                label="Mensagem do post"
                size={500}
            />
        )
    }
    function ExerciseRegistrySwitch() {
        const [duration, setDuration] = useState(REF_config.current.activity?.duration || 60);
        const [intensity, setIntensity] = useState(REF_config.current.activity?.intensity || 'medium');
        const [type, setType] = useState(REF_config.current.activity?.mode || 'gym');

        function Title({ icon, title }) {
            return (
                <div className="exercise-title mt-2 mb-1">
                    {icon}
                    <h4>{title}</h4>
                </div>
            )
        }

        function Option({ icon, title, value, path }) {
            const isActive = REF_config.current.activity?.[path] === value;
            return (
                <div
                    className={"exercise-option " + (isActive ? "active" : "")}
                    onClick={() => handleUpdate(path, value)}>
                    {icon}
                    <span>{title}</span>
                </div>
            )
        }


        function handleUpdate(path, value) {
            if (path === "duration") {
                setDuration(value);
            } else if (path === "intensity") {
                setIntensity(value);
            } else if (path === "mode") {
                setType(value);
            }
            REF_config.current.activity = {
                ...REF_config.current.activity,
                [path]: value
            };
        }

        return (
            <div className="exercise-registry-switch mt-4 mb-1">
                <div className="exercise-registry-switch-content pl-1">
                    <h4 className="bold">Registrar exercício</h4>
                    <Switch
                        checked={exerciseRegistry}
                        onChange={(e) => setExerciseRegistry(e.target.checked)}
                    />
                </div>


                {
                    exerciseRegistry ? (
                        <>
                            <Divider className="mt-1" />

                            <div className="exercise-registry-body">
                                <Title icon={<ShutterSpeedRounded />} title="Duração" />
                                <div className="exercise-options-row">
                                    {
                                        exerciseOptions.duration.map((option) => (
                                            <Option title={option.title} value={option.value} path="duration" />
                                        ))
                                    }
                                    <Input.Integer
                                        value={duration || ''}
                                        onInput={setDuration}
                                        placeholder="Duração"
                                        label="Ou, insira uma duração personalizada (em minutos)"
                                        max={600}
                                    />
                                </div>

                                <Title icon={<BoltRounded />} title="Intensidade" />
                                <div className="exercise-options-row">
                                    {
                                        exerciseOptions.intensity.map((option) => (
                                            <Option title={option.title} value={option.value} path="intensity" />
                                        ))
                                    }
                                </div>

                                <Title icon={<DirectionsRunRounded />} title="Modalidade" />
                                <div className="exercise-options-row">
                                    {
                                        exerciseOptions.mode.map((option) => (
                                            <Option title={option.title} value={option.value} path="mode" />
                                        ))
                                    }
                                </div>
                            </div>
                        </>
                    ) : null
                }
            </div>
        )
    }


    return (
        <CustomModal
            maxWidth={450}
            bottomButtonSumbitText="Publicar agora"
            bottomButtonCancelText="Cancelar"
            loading={loading}
            title="Publicar novo post"
            handleSubmit={handleSubmit}
            open={open}
            handleClose={() => setOpen(false)}
            bodyComponent={
                open ? (
                    <div className="px-4 py-1">
                        <Asset />
                        <Message />
                        <ExerciseRegistrySwitch />


                    </div>
                ) : null
            }
        />
    );
}
